import { Component, Input, OnInit } from '@angular/core';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { RateCodes } from 'src/app/models/commission/rate-codes.model';
import { AddUser } from 'src/app/models/manageUsers/add-user.model';
import { LoggerService } from 'src/app/service/logger.service';
import { ManageUserService } from 'src/app/service/manage-user.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { NotificationService } from 'src/app/service/notification.service';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { NgForm } from '@angular/forms';
import { UserManagementModel } from 'src/app/models/userManagementModel/usermang.model';
import { GlobalService } from 'src/app/service/global.service';
import { ManageCodesService } from 'src/app/service/managecodes.service';

@Component({
  selector: 'app-manage-all-codes',
  templateUrl: './manage-all-codes.component.html',
  styleUrls: ['./manage-all-codes.component.css']
})
export class ManageAllCodesComponent implements OnInit {

  rateCodeModel = new RateCodes(null, null, null, null, null, null, null, null, null, null, null, [], [], null, '', '', '');
  rateCodeData: RateCodes[] = [];
  filteredRateCodeData: RateCodes[] = [];
  historicalRateCodeData: RateCodes[] = [];
  duplicateRateCodeData: RateCodes[] = [];
  resetFilteredRateCodeData: RateCodes[] = [];
  historyResetFilteredRateCodeData: RateCodes[] = [];
  filterData: RateCodes[] = [];
  corpsData: RateCodes[] = [];
  productsData: RateCodes[] = [];

  filteredValues: RateCodes[] = [];
  rowcolor: string = 'tablerow';
  corps: number[] = [];
  changeColor: boolean[] = [];
  color: boolean = false;
  isShowCodes: boolean = false;
  isShowCorps: boolean = true;
  pid: number = 0;
  corpId: number = 0;
  filter: boolean = false;
  count: number = 0;
  userData: AddUser[] = [];
  salesChannels: string[] = [];
  commPlans: string[] = [];
  flags: string[] = ['Y', 'N'];
  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';
  @Input() headderText: string = 'Manage All Codes';
  @Input() isPromo = false;
  dataForExcel = [];
  columnsExcelData: any;
  ordersTableExcelHeaderColumns: TableColumn[];
  exportExcelRateCodeData: RateCodes[] = [];
  isAccessDisabled: boolean = false;

  menusFilter: UserManagementModel[] = [];
  isView: boolean = true;
  permissionCheck: any;
  errorMessage: string;
  constructor(private manageCodesService: ManageCodesService, 
    private logger: LoggerService, private manageUserService: ManageUserService,
    private authGurdService: AuthGaurdService, private notificationService: NotificationService,
    private httpService: HttpClient, private globalService: GlobalService,
    private exportExcelService: ExportExcelService) { }

  ngOnInit(): void {
    this.init();
    this.isAccessDisabled = this.globalService._permissionCheck('manage-all-codes');
    if (this.isAccessDisabled) {
      this.notificationService.notify(NotificationType.WARNING, "Edit Permission has Disabled Contact To Adminstrator");
    }
  }

  public init() {
    this.initializeExcelHeaders()
    this.rateCodeModel = new RateCodes(null, null, null, null, null, null, null, null, null, null, null, [], [], null, '', '', '');
    this.rateCodeData = [];
    this.filteredRateCodeData = [];
    this.resetFilteredRateCodeData = [];
    this.filterData = [];
    //this.corpsData = [];
    //this.productsData = [];
    this.filteredValues = [];
    this.rowcolor = 'tablerow';
    //this.corps = [];
    this.changeColor = [];
    this.color = false;
    this.isShowCodes = false;
    this.isShowCorps = true;
    //this.pid = 0;
    //this.corpId = 0;
    this.filter = false;
    this.count = 0;
    this.userData = [];
    //this.salesChannels = [];
    this.commPlans = [];
    this.flags = ['Y', 'N'];

    if (this.corpId > 0) {
      this.getRateCodeDataByCorps(event, this.corpId);
    }
    else if (this.pid > 0) {
      this.findRateCodeData(this.pid);
    } else
      this.getSalesChannel();
  }

  getSalesChannel() {
    this.manageUserService.getPrePopulatedUserData().subscribe((data: any) => {
      this.logger.info(data);
      this.userData = data;
      for (let userInfo of this.userData) {
        if (userInfo.sales_rep_channel != null && userInfo.sales_rep_channel != 'NA')
          this.salesChannels.push(userInfo.sales_rep_channel_desc);
        if (this.salesChannels.length > 1) {
          this.salesChannels.sort((a, b) =>
            a.localeCompare(b));
        }
      }

    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
  }

  getProductData(event: any) {
    console.log("getProductData() called");
    console.log(event.target.value);
    if (event.target.value === '-1') {
      this.productsData = [];
      this.isShowCodes = false;
      this.corpsData = [];
      this.corpId = 0;
    }
    else if (event.target.value === 'All') {
      this.getAllProducts();
      this.isShowCodes = false;
    }
    else {
      this.getCodeTypes(event.target.value);
      this.isShowCodes = false;
    }
  }

  getAllProducts() {
    this.manageCodesService.getCodeTypes()
      .subscribe((data: any) => {
        this.logger.info(data);
        this.productsData = data;
        console.log(this.productsData);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getCodeTypes(salesChannel: string) {
    this.manageCodesService.getProducts(salesChannel)
      .subscribe((data: any) => {
        this.logger.info(data);
        this.productsData = data;
        // console.log(this.productsData);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getCorps() {
    this.manageCodesService.getCorps()
      .subscribe((data: any) => {
        this.logger.info(data);
        this.corpsData = data;
        for (let corpdata of this.corpsData) {
          this.corps.push(corpdata.corp);
        }
        // console.log(this.corpsData);
        this.getAllCodes();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public filterbyCode(value: string): RateCodes[] {
    const filterValue = this._normalizeValue(value);
    this.filteredValues = this.rateCodeData.filter(street => this._normalizeValue(street.rcode).includes(filterValue));
    console.log(this.filteredValues);
    this.rateCodeData = this.filteredValues;
    return this.rateCodeData.filter(street => this._normalizeValue(street.rcode).includes(filterValue));
  }

  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }

  clickedRow(e: any, rateCode: RateCodes) {
    var numeric = Number(e.target.innerText);
    this.rowcolor = "tablerowB";
    let condi: boolean = true;
    rateCode.corps.forEach((value: any, index: any) => {
      if (value === numeric) {
        rateCode.corps.splice(index, 1);
        condi = false;
      }
    });
    if (condi) {
      rateCode.corps.push(numeric);
    }
    console.log(' corps====', rateCode);
  }

  public getRateCodeData(event: any) {
    console.log("getRateCodeData() called");
    this.count = 0;
    //if(this.pid === 0)
    this.pid = event.target.value;
    this.findRateCodeData(event.target.value);

  }

  private findRateCodeData(value: any) {
    console.log("findRateCodeData() called");
    if (value === '-1') {
      this.pid = 0;
      this.isShowCodes = false;
      this.filteredRateCodeData = [];
      this.resetFilteredRateCodeData = [];
      this.corpsData = [];
      this.corpId = 0;
      this.rateCodeData = [];
    }
    else {
      this.isShowCodes = true;
      this.isShowCorps = true;
      this.corpId = 0;
      this.count = 0;
      this.filteredRateCodeData = [];
      this.resetFilteredRateCodeData = [];
      this.getCorps();
      this.getcommPlans();
    }
  }

  public getAllCodes() {
    console.log("getAllCodes() called");
    this.manageCodesService.getAllCodes(this.pid, this.corpId)
      .subscribe((data: any) => {
        this.logger.info(data);
        this.rateCodeData = data;
        //console.log(this.rateCodeData);
        if (this.rateCodeData.length > 0) {
          this.filterRateCode();
          this.selectedCorps(this.filteredRateCodeData);
        }
        // console.log(this.filteredRateCodeData);

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  private getcommPlans() {
    this.manageCodesService.getcommPlans(this.pid)
      .subscribe((data: any) => {
        this.logger.info(data);
        this.commPlans = data;
        console.log(this.commPlans);
        //this.getCorps();

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  checkAll(rateCode: any) {
    rateCode.changeColor = [];
    rateCode.corps = [];
    for (let corp of this.corps) {
      rateCode.changeColor.push(true);
      rateCode.corps.push(corp);
    }
  }

  uncheckAll(rateCode: any) {
    rateCode.changeColor = [];
    rateCode.corps = [];
  }


  close(kpiForm: NgForm) {
    kpiForm.reset();
  }

  showHistory(rateCode: any) {
    this.historicalRateCodeData = [];
    this.rateCodeData.forEach((rCodeData: any, index: any) => {
      if (rCodeData.rcode == rateCode.rcode &&
        rCodeData.effective_date < rateCode.effective_date) {
        // this.historicalRateCodeData.push(rCodeData)
        this.filterHistoryRateCode(rCodeData);
      }
    });
    this.selectedCorps(this.historicalRateCodeData);
    this.historicalRateCodeData = this.historicalRateCodeData.reverse();
    if (this.historicalRateCodeData.length == 0) {
      this.notificationService.notify(NotificationType.WARNING, "The RateCode " + rateCode.rcode + " Doesn't Have HistoricalRateCodeData ");
    }
    console.log(this.historicalRateCodeData);
  }

  public filterHistoryRateCode(rcodeData: RateCodes) {
    //  for (let rcodeData of this.rateCodeData) {
    if (this.historicalRateCodeData.length === 0) {
      //console.log("1st time ", rcodeData)
      this.historicalRateCodeData.push(rcodeData);
      this.historicalRateCodeData[0].corps.push(rcodeData.corp);
      this.historyResetFilteredRateCodeData = [];
      this.historyResetFilteredRateCodeData.push(rcodeData);
      this.historyResetFilteredRateCodeData[0].corps = [];
      this.historyResetFilteredRateCodeData[0].corps.push(rcodeData.corp);
    }
    else {
      //this.historyResetFilteredRateCodeData.forEach((resetfiltrRateCodeData: any, index: any) => {

      if (this.historyResetFilteredRateCodeData[0].rcode === rcodeData.rcode &&
        this.historyResetFilteredRateCodeData[0].valid_from_dt === rcodeData.valid_from_dt &&
        this.historyResetFilteredRateCodeData[0].valid_to_dt === rcodeData.valid_to_dt) {
        // console.log(' rocde  ', rcodeData)
        this.historyResetFilteredRateCodeData[0].corps.push(rcodeData.corp);
        this.filter = true;
      }
      else {
        // if (this.historicalRateCodeData[0].rcode != resetfiltrRateCodeData.rcode)
        this.historicalRateCodeData.push(rcodeData);
        this.historicalRateCodeData[0].corps.push(rcodeData.corp);

        this.historyResetFilteredRateCodeData = []
        this.historyResetFilteredRateCodeData.push(rcodeData);
        this.historyResetFilteredRateCodeData[0].corps.push(rcodeData.corp);
        this.count = 0;
      }

      //});
    }

    //}
    // if (this.historyResetFilteredRateCodeData.length > 0 ) {
    //   for(let rcodeData of this.historyResetFilteredRateCodeData){
    //   this.historicalRateCodeData.push(rcodeData);
    //   }
    // }
  }

  public filterRateCode() {
    console.log("filterRateCode() called");
    if (this.rateCodeData.length === 0) {
      this.filteredRateCodeData = [];
    }
    for (let rcodeData of this.rateCodeData) {
      if (this.filteredRateCodeData.length === 0) {
        //console.log("1st time ", rcodeData)
        this.filteredRateCodeData.push(rcodeData);
        this.filteredRateCodeData[0].corps.push(rcodeData.corp);
        this.resetFilteredRateCodeData.push(rcodeData);
        this.resetFilteredRateCodeData[0].corps = [];
        this.resetFilteredRateCodeData[0].corps.push(rcodeData.corp);
      } else {
        this.resetFilteredRateCodeData.forEach((resetfiltrRateCodeData: any, index: any) => {
          this.count = this.count + 1;
          // console.log("====== count ==", this.count + "  === ", resetfiltrRateCodeData.corps.length)
          if (resetfiltrRateCodeData.rcode === rcodeData.rcode &&
            resetfiltrRateCodeData.valid_from_dt === rcodeData.valid_from_dt &&
            resetfiltrRateCodeData.valid_to_dt === rcodeData.valid_to_dt) {
            //console.log(' rocde  ', rcodeData)
            resetfiltrRateCodeData.corps.push(rcodeData.corp);
            this.filter = true;
          }
          else if (resetfiltrRateCodeData.corps.length == this.count) {
            // console.log("2st time ", resetfiltrRateCodeData)

            if (resetfiltrRateCodeData.rcode === rcodeData.rcode) {
              this.filteredRateCodeData.forEach((filtrRateCodeData: any, index: any) => {
                if (filtrRateCodeData.rcode == rcodeData.rcode &&
                  filtrRateCodeData.effective_date < rcodeData.effective_date) {
                  this.filteredRateCodeData.splice(index, 1);
                  //this.filteredRateCodeData.push(rcodeData);
                }
              });
            }

            else if (this.filteredRateCodeData[0].rcode != resetfiltrRateCodeData.rcode)
              this.filteredRateCodeData.push(resetfiltrRateCodeData);

            this.resetFilteredRateCodeData = []
            this.resetFilteredRateCodeData.push(rcodeData);
            this.resetFilteredRateCodeData[this.resetFilteredRateCodeData.length - 1].corps.push(rcodeData.corp);
            this.count = 0;
          }

        });
      }

    }

    if (this.resetFilteredRateCodeData.length > 0) {
      for (let rcodeData of this.resetFilteredRateCodeData) {
        this.filteredRateCodeData.push(rcodeData);
      }
    }
    this.filteredRateCodeData = this.filteredRateCodeData.filter((v, i) => this.filteredRateCodeData.findIndex(item => item.rcode == v.rcode && item.effective_date == v.effective_date) === i);
    //this.filteredRateCodeData = this.filteredRateCodeData.sort((a, b) => (a.rcode < b.rcode && a.effective_date < b.effective_date) ? -1 : 1);
    console.log(this.filteredRateCodeData);
  }

  public getRateCodeDataByCorps(event?: any, corp?: number) {
    console.log("getRateCodeDataByCorps() called");
    this.isShowCodes = true;
    this.isShowCorps = false;
    if (corp) {
      this.corpId = corp;
      this.getAllCodesByCorpId(this.corpId);
    }
    else if (event.target.value === 'All') {
      this.filteredRateCodeData = [];
      this.resetFilteredRateCodeData = [];
      this.isShowCorps = true;
      this.count = 0;
      this.corpId = 0;
      this.getAllCodes();
    }
    else {
      this.corpId = event.target.value;
      this.getAllCodesByCorpId(this.corpId);
    }

  }

  private getAllCodesByCorpId(corpId: number) {
    console.log("getAllCodesByCorpId() called");
    if (this.pid > 0) {
      this.manageCodesService.getAllCodes(this.pid, corpId)
        .subscribe((data: any) => {
          this.logger.info(data);
          this.filteredRateCodeData = data;
          this.selectedCorps(this.filteredRateCodeData);
          console.log(this.rateCodeData);
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
    }
    else {
      this.isShowCodes = false;
      this.filteredRateCodeData = [];
    }
  }

  private selectedCorps(filteredRateCodeData: any) {

    for (let rateCode of filteredRateCodeData) {

      for (let corp of this.corps) {
        this.color = false;
        rateCode.corps.forEach((value: any, index: any) => {
          if (value === corp) {
            // console.log('==== on init ', value);
            this.color = true;
          }
        });
        if (this.color) {
          rateCode.changeColor.push(true)
          this.changeColor.push(true);
        }
        else {
          rateCode.changeColor.push(false)
          this.changeColor.push(false);
        }
      }
      // console.log(rateCode.changeColor);
    }
  }

  public addRateCode() {

    if (this.filteredRateCodeData?.length > 0) {
      this.count = 0;
      this.filteredRateCodeData.forEach((filtrRateCodeData: RateCodes, index: any) => {
        this.count = this.count + 1;
        if (filtrRateCodeData.rcode == this.rateCodeModel.rcode &&
          (filtrRateCodeData.effective_date >= this.rateCodeModel.effective_date ||
            filtrRateCodeData.proAmount === this.rateCodeModel.proAmount)) {
          this.notificationService.notify(NotificationType.ERROR, "The RateCode EffectiveDate Shold Be Greater Than Previous & PromAmount Should Be Diffrent");
        }
        else if (this.filteredRateCodeData.length === this.count) {
          this.addRateCodeValidation()
        }
      });
    }
    else
      this.addRateCodeValidation()

  }

  private addRateCodeValidation() {
    if (this.rateCodeModel.corps.length > 0 && this.rateCodeModel.rcode != null &&
      this.rateCodeModel.f_level != null
      && this.rateCodeModel.valid_from_dt != null && this.rateCodeModel.valid_to_dt != null &&
      this.rateCodeModel.effective_date != null) {
      if (this.rateCodeModel.corps.length == 0) {
        this.rateCodeModel.corps.push(this.corpId);
      }
      this.duplicateRateCodeData = this.filteredRateCodeData.filter((RateCode) => (RateCode.rcode == this.rateCodeModel.rcode));
      console.log(' rate code ==', this.rateCodeModel);
      if (this.duplicateRateCodeData.length > 0 &&
        this.duplicateRateCodeData[0].valid_to_dt < this.rateCodeModel.valid_from_dt) {

      }
      this.rateCodeModel.productid = this.pid;
      this.rateCodeModel.createdBy =localStorage.getItem('CURRENT_USER_NAME_SESSION');
      this.manageCodesService.addRateCode(this.rateCodeModel)
        .subscribe(response => {
          //response = response as ErrorResponseMessage;
          //console.log(' relicate resp=== ', response);
          this.reloadPage();

        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
    }
    else {
      this.notificationService.notify(NotificationType.ERROR, "Please enter all the mandatory fields");
    }
  }

  public updateRateCode(rateCode: RateCodes) {
    if (rateCode.corps.length == 0) {
      rateCode.corps.push(this.corpId);
    }

    this.rateCodeModel.productid = this.pid;
    rateCode.updatedBy =localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.manageCodesService.updateRateCode(rateCode)
      .subscribe(response => {
        //response = response as ErrorResponseMessage;
        //console.log(' relicate resp=== ', response);
        this.reloadPage();

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  private reloadPage() {
    this.init()
    //window.location.reload();
  }


  // public exportExcel(): void {
  //   console.log('Export excel==')
  //   const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.rateCodeData);
  //   const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
  //   const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  //   this.saveExcelFile(excelBuffer, this.headderText);
  // }
  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.ExcelManageAllCodes;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  public exportExcel() {
    console.log(this.rateCodeData);
    this.exportExcelRateCodeData = JSON.parse(JSON.stringify(this.rateCodeData));
    console.log(this.exportExcelRateCodeData);
    for (let js of this.exportExcelRateCodeData) {
      delete js.productid;
      delete js.productname;
      delete js.corp_id;
      delete js.rname;
      delete js.corps;
      delete js.changeColor;
      delete js.effdate;
      delete js.status;
      delete js.createdBy;
      delete js.updatedBy;

    }
    this.dataForExcel = [];
    let reportData = null;
    this.exportExcelRateCodeData.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row))
    })
     reportData = {
      title: 'Manage All Codes',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.exportExcelService.exportExcel(reportData);
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.fileType });
    saveAs(data, fileName + this.fileExtension);
  }

  public printPage() {
    window.print();
  }
}
